import React from "react";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	backdrop: {
		position: "fixed", // importante!
		top: -10,
		left: -10,
		width: "110vw",
		height: "110vh",
		zIndex: theme.zIndex.modal + 999, // bem alto
		color: "inherit",
		backgroundColor: "rgba(0, 0, 0, 0.5)", // opcional: escurecer o fundo
	},
}));

const BackdropLoading = () => {
	const classes = useStyles();
	return (
		<Backdrop className={classes.backdrop} open={true}>
			<CircularProgress color="inherit" />
		</Backdrop>
	);
};

export default BackdropLoading;
